import { all, takeEvery, select, put, call } from 'redux-saga/effects';
import actions from "./actions";
import {getClientActiveConsentsApi,
        getAllClientConsentsStoryApi
} from "../../services/consent.service"
import {ReducerType} from "../reducer.type";
import { AxiosResponse } from 'axios';
import { WorkspaceType } from '../user/user.type';
import logError from "../../utils/logError";
// import { getConsentTypesApi } from "../../services/consent_type.service"

const getItems = (state: ReducerType) => state.user.activeWorkspace;


export function* GET_ALL_ACTIVE_CONSENTS(action: {payload: string, type: string}) {
    const items: WorkspaceType = yield select(getItems);
    let clientId = action.payload;
    try {
        const response: AxiosResponse<any> = yield call(
          getClientActiveConsentsApi,
          items.uuid,
          clientId
        );
        if (response.data) {
            yield put({
                type: actions.SET_ACTIVE_CONSENTS,
                payload: response.data
            })
        }
    } catch (e) { logError("redux/consents/sagas/GET_ALL_ACTIVE_CONSENTS", e); }
}

export function* GET_ALL_CONSENTS_STORY(action: {payload: string, type: string}) {
    const items: WorkspaceType = yield select(getItems);
    let clientId = action.payload;
    try {
        const response : AxiosResponse<any> = yield call(getAllClientConsentsStoryApi,items.uuid, clientId);
        if (response.data) {
            yield put({
                type: actions.SET_CONSENTS_STORY,
                payload: response.data
            })
        }
    } catch (e) { logError("redux/consents/sagas/GET_ALL_CONSENTS_STORY", e); }
}

export default function* rootSaga() {
    yield all([
        takeEvery(actions.GET_ACTIVE_CONSENTS, GET_ALL_ACTIVE_CONSENTS),
        takeEvery(actions.GET_CONSENTS_STORY, GET_ALL_CONSENTS_STORY),
    ])
}
